import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// warning that otherwise triggers CRA's react-error-overlay (dev-only) and steals
// click events from dialogs in the preview build. Harmless in production.
if (typeof window !== "undefined") {
  const RO_MSG = "ResizeObserver loop";
  window.addEventListener("error", (e) => {
    if (e?.message && e.message.includes(RO_MSG)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
